/**
 * Copyright (c) 2026 上海安能聚创供应链管理有限公司.
 * All rights reserved.
 * 公司内部代码，未经书面授权，不得以任何形式复制、传播或用于与本项目无关的其他用途。
 */
import React from 'react';
import { changeLocalApiInInterceptors } from '@aned/lib';
import { SentryErrorBoundary, reportSentryCustomError } from '@aned/sentry';
import { initSentry } from './utils/track/sentry/initSentry';

changeLocalApiInInterceptors({ module: 'route' });

// 先初始化 Sentry，再挂根级错误边界（保证全局兜底）
initSentry();

// 本地开发没有部署 tdcs / routetime，跨工程菜单 fallback 到测试云环境域名
const CLOUD_ENV_ORIGIN = 'https://eagle.test.ane56.com';

// router.json 里跨工程菜单的 domain 是相对值（tdcs / routetime），
// 运行时按当前域名拼接，避免构建时写死导致新环境（如 uat）跳生产
function patchRouteDomain(routes = []) {
  routes.forEach((item) => {
    if (item.domain && !/^https?:\/\//.test(item.domain)) {
      const isLocal = /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
      const origin = isLocal ? CLOUD_ENV_ORIGIN : window.location.origin;
      item.domain = `${origin}/${item.domain}`;
    }
    if (item.routes) patchRouteDomain(item.routes);
  });
}

export function patchRoutes({ routes }) {
  patchRouteDomain(routes);
}

// 根节点统一包 Sentry 渲染错误边界，防止未捕获渲染异常导致白屏
export function rootContainer(container) {
  return <SentryErrorBoundary name="root">{container}</SentryErrorBoundary>;
}

// dva effect/subscription 异常统一出口：上报 Sentry，不新增 UI 提示保持原有用户行为
export const dva = {
  config: {
    onError(error) {
      reportSentryCustomError({
        message: 'DVA 副作用异常',
        error,
        extra: {
          scene: 'dva onError',
        },
      });
    },
  },
};

export const qiankun = {
  // 应用加载之前
  async bootstrap(props) {
    console.log('routeForecast bootstrap', props);
  },
  // 应用 render 之前触发
  async mount(props) {
    window.microProps = {
      container: props?.container,
    };
    console.log('routeForecast mount', props);
  },
  // 应用卸载之后触发
  async unmount(props) {
    console.log('routeForecast unmount', props);
  },
};
